<template>
  <myDialog
    class="orderTableSelect"
    ref="myDialog"
    :title="labelName"
    @submitData="submitData"
    @dialogClose="dialogClose"
    width="1000px"
  >
    <template slot="content">
      <el-form :inline="true" :model="searchConditionForm" @submit.native.prevent class="demo-form-inline">
        <div class="formBox" v-if="labelName == '销售订单'" :key="1">
          <el-form-item label="销售单号：" size="small">
            <el-input v-model="searchConditionForm.orderNumber" @keydown.enter.native="searchBtn" placeholder="销售订单号" clearable></el-input>
          </el-form-item>
        </div>
        <div class="formBox" v-else-if="labelName == '组装工单' || labelName == '组装工单多选'" :key="2">
          <el-form-item label="组装工单：" size="small">
            <el-input v-model="searchConditionForm.orderNumber" @keydown.enter.native="searchBtn" placeholder="组装工单号" clearable></el-input>
          </el-form-item>
        </div>
        <div class="formBox" v-else-if="labelName == '发货单'" :key="3">
          <el-form-item label="发货单号：" size="small">
            <el-input v-model="searchConditionForm.orderNumber" @keydown.enter.native="searchBtn" placeholder="发货单号" clearable></el-input>
          </el-form-item>
        </div>
        <div class="formBox" v-else-if="labelName == '员工选择'" :key="4">
          <el-form-item label="Key：" size="small">
            <el-input v-model="searchConditionForm.key" @keydown.enter.native="searchBtn" placeholder="输入Key模糊查询" clearable></el-input>
          </el-form-item>
        </div>
        <div class="formBox" v-else-if="labelName == '包装工单'" :key="5">
          <el-form-item label="包装工单：" size="small">
            <el-input v-model="searchConditionForm.orderNumber" @keydown.enter.native="searchBtn" placeholder="包装工单号" clearable></el-input>
          </el-form-item>
        </div>
        <div class="formBox" v-else-if="labelName == 'PE工程师'" key="PE">
          <el-form-item label="Key：" size="small">
            <el-input v-model="searchConditionForm.key" @keydown.enter.native="searchBtn" placeholder="输入key模糊查询" clearable></el-input>
          </el-form-item>
        </div>
        <div class="formBox" v-else-if="labelName == '邮箱选择'" key="MAIL">
          <el-form-item label="Key：" size="small">
            <el-input v-model="searchConditionForm.key" @keydown.enter.native="searchBtn" placeholder="输入key模糊查询" clearable></el-input>
          </el-form-item>
        </div>
        <div class="formBox" v-else-if="labelName == 'SMT工单'" :key="SMT">
          <el-form-item label="SMT工单：" size="small">
            <el-input v-model="searchConditionForm.orderNumber" @keydown.enter.native="searchBtn" placeholder="SMT工单号" clearable></el-input>
          </el-form-item>
        </div>
        <el-form-item size="small">
          <el-button type="primary" @click="searchBtn">查询</el-button>
        </el-form-item>
      </el-form>
      <div class="selectRowBox">
        <span>最近选择：</span>
        <span v-if="labelName == '包装工单' || this.labelName == '组装工单多选'">
          <span
            class="rowItem"
            v-for="(item, index) in filterHistory"
            :key="index"
            :class="{'selectRowItem': selectRow.map(item => item.id).includes(item.id)}"
            @click="selectRowArrayBtn(item)"
          >{{item.orderNumber || item.name}}</span>
        </span>
        <span v-else>
          <span
            class="rowItem"
            v-for="(item, index) in filterHistory"
            :key="index"
            :class="{'selectRowItem': item.id == selectRow.id}"
            @click="selectRowBtn(item)"
          >{{item.orderNumber || item.name}}</span>
        </span>
        <span class="rowItem" v-if="filterHistory.length == 0">-</span>
      </div>
      <div class="tableBox" v-if="labelName == '销售订单'" :key="1">
        <el-table
          stripe
          :data="tableData"
          ref="multipleTable"
          border
          style="width: 100%"
          height="100%"
          size="mini"
          @sort-change="sortChange"
          @select="selectChange"
          @select-all="selectAllChange"
        >
          <el-table-column type="selection" width="50" align="center"></el-table-column>
          <el-table-column type="index" width="50" align="center" :index="pagination.beginIndex"></el-table-column>
          <el-table-column
            prop="orderNumber"
            label="销售单号"
            min-width="110px"
            align="center"
            show-overflow-tooltip
            sortable="custom"
          >
            <template slot-scope="scope">
              <span>{{scope.row.orderNumber}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="customerId"
            label="客户"
            min-width="110px"
            align="center"
            show-overflow-tooltip
            sortable="custom"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.customer">{{scope.row.customer.name}}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="modelId"
            label="产品型号"
            min-width="110px"
            align="center"
            show-overflow-tooltip
            sortable="custom"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.product">{{scope.row.product.code}}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="quantity" label="数量" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.quantity">{{scope.row.quantity}}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="sales" label="销售员" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.sales">{{scope.row.sales.name}}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="tableBox" v-else-if="labelName == '组装工单'" key="production">
        <el-table
          stripe
          :data="tableData"
          ref="multipleTable"
          border
          style="width: 100%"
          height="100%"
          size="mini"
          @sort-change="sortChange"
          @select="selectChange"
          @select-all="selectAllChange"
        >
          <el-table-column type="selection" width="50" align="center"></el-table-column>
          <el-table-column type="index" width="50" align="center" :index="pagination.beginIndex"></el-table-column>
          <el-table-column
            prop="orderNumber"
            label="组装工单"
            min-width="110"
            align="center"
            show-overflow-tooltip
            sortable="custom"
          >
            <template slot-scope="scope">
              <span>{{scope.row.orderNumber}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="customerId"
            label="客户"
            min-width="110"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span v-if="scope.row.customer">{{scope.row.customer.name}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="productId" label="产品型号" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.product">{{scope.row.product.code}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="quantity" label="产品数量" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="status" label="状态" width="95px" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.status" class="textOverflow">{{scope.row.status.title}}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="tableBox" v-else-if="labelName == '组装工单多选'" key="productionMul">
        <el-table
          stripe
          :data="tableData"
          ref="multipleTable"
          border
          style="width: 100%"
          height="100%"
          size="mini"
          @sort-change="sortChange"
          @select="selectChange2"
          @select-all="selectAllChange2"
        >
          <el-table-column type="selection" width="50" align="center"></el-table-column>
          <el-table-column type="index" width="50" align="center" :index="pagination.beginIndex"></el-table-column>
          <el-table-column
            prop="orderNumber"
            label="组装工单"
            min-width="110"
            align="center"
            show-overflow-tooltip
            sortable="custom"
          >
            <template slot-scope="scope">
              <span>{{scope.row.orderNumber}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="customerId"
            label="客户"
            min-width="110"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span v-if="scope.row.customer">{{scope.row.customer.name}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="productId" label="产品型号" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.product">{{scope.row.product.code}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="quantity" label="产品数量" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="status" label="状态" width="95px" align="center" show-overflow-tooltip>
            <template slot-scope="scope" class="textOverflow">
              <span v-if="scope.row.status">{{scope.row.status.title}}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="tableBox" v-else-if="labelName == '发货单'" :key="3">
        <el-table
          stripe
          :data="tableData"
          ref="multipleTable"
          border
          style="width: 100%"
          height="100%"
          size="mini"
          @sort-change="sortChange"
          @select="selectChange"
          @select-all="selectAllChange"
        >
          <el-table-column type="selection" width="50" align="center"></el-table-column>
          <el-table-column type="index" width="50" align="center" :index="pagination.beginIndex"></el-table-column>
          <el-table-column
            prop="orderNumber"
            label="发货单号"
            min-width="110"
            align="center"
            show-overflow-tooltip
            sortable="custom"
          ></el-table-column>
          <el-table-column
            prop="customerId"
            label="客户"
            min-width="110"
            align="center"
            show-overflow-tooltip
            sortable="custom"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.customer">{{scope.row.customer.name}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="destination" label="目的地" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.destination">{{scope.row.destination}}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="express" label="承运人" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.express">{{scope.row.express}}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="expressNumber" label="车牌号" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.expressNumber">{{scope.row.expressNumber}}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="status"
            label="工单状态"
            align="center"
            show-overflow-tooltip
            sortable="custom"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.status">{{scope.row.status.title}}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="tableBox" v-else-if="labelName == '员工选择'" :key="4">
        <el-table
          stripe
          :data="tableData"
          ref="multipleTable"
          border
          style="width: 100%"
          height="100%"
          size="mini"
          @sort-change="sortChange"
          @select="selectChange"
          @select-all="selectAllChange"
        >
          <el-table-column type="selection" width="50" align="center"></el-table-column>
          <el-table-column type="index" width="50" align="center" :index="pagination.beginIndex"></el-table-column>
          <el-table-column
            prop="employeeNum"
            label="工号"
            align="center"
            sortable="custom"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="name"
            label="姓名"
            align="center"
            sortable="custom"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column prop="organization" label="所在部门" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.organization">{{scope.row.organization.name}}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="workPosition" label="岗位" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.workPosition">{{scope.row.workPosition.name}}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="tableBox" v-else-if="labelName == '包装工单'" :key="5">
        <el-table
          stripe
          :data="tableData"
          ref="multipleTable"
          border
          style="width: 100%"
          height="100%"
          size="mini"
          @sort-change="sortChange"
          @select="selectChange2"
          @select-all="selectAllChange2"
        >
          <el-table-column type="selection" width="50" align="center"></el-table-column>
          <el-table-column type="index" width="50" align="center" :index="pagination.beginIndex"></el-table-column>
          <el-table-column
            prop="orderNumber"
            label="包装单号"
            align="center"
            min-width="110"
            show-overflow-tooltip
            sortable="custom"
          >
            <template slot-scope="scope">
              <span>{{scope.row.orderNumber}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="customerId"
            label="客户"
            align="center"
            min-width="80"
            show-overflow-tooltip
            sortable="custom"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.customer">{{scope.row.customer.name}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="type" label="包装类型" align="center" width="120" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.type">{{scope.row.type.title}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="quantity"
            label="总数量(PCS)"
            align="center"
            width="120"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="amount"
            label="已包装(PCS)"
            align="center"
            width="120"
            show-overflow-tooltip
          ></el-table-column>
        </el-table>
      </div>
      <div class="tableBox" v-else-if="labelName == 'PE工程师'" key="PE">
        <el-table
          stripe
          :data="tableData"
          ref="multipleTable"
          border
          style="width: 100%"
          height="100%"
          size="mini"
          @sort-change="sortChange"
          @select="selectChange"
          @select-all="selectAllChange"
        >
          <el-table-column type="selection" width="50" align="center"></el-table-column>
          <el-table-column type="index" width="50" align="center" :index="pagination.beginIndex"></el-table-column>
          <el-table-column
            prop="employeeNum"
            label="工号"
            align="center"
            sortable="custom"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="name"
            label="姓名"
            align="center"
            sortable="custom"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column prop="organization" label="所在部门" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.organization">{{scope.row.organization.name}}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="workPosition" label="岗位" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.workPosition">{{scope.row.workPosition.name}}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="tableBox" v-else-if="labelName == '邮箱选择'" key="MAIL">
        <el-table
          stripe
          :data="tableData"
          ref="multipleTable"
          border
          style="width: 100%"
          height="100%"
          size="mini"
          @sort-change="sortChange"
          @select="selectChangeMail"
          @select-all="selectAllChange"
        >
          <el-table-column type="selection" width="50" align="center"></el-table-column>
          <el-table-column type="index" width="50" align="center" :index="pagination.beginIndex"></el-table-column>
          <el-table-column
            prop="employeeNum"
            label="工号"
            align="center"
            sortable="custom"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="name"
            label="姓名"
            align="center"
            sortable="custom"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column prop="email" label="邮箱" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.email">{{scope.row.email}}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          
        </el-table>
      </div>
      <div class="tableBox" v-else-if="labelName == 'SMT工单'" key="SMT">
        <el-table
            stripe
            :data="tableData"
            ref="multipleTable"
            border
            style="width: 100%"
            height="100%"
            size="mini"
            @sort-change="sortChange"
            @select="selectChange"
            @select-all="selectAllChange"
        >
          <el-table-column type="selection" width="50" align="center"></el-table-column>
          <el-table-column type="index" width="50" align="center" :index="pagination.beginIndex"></el-table-column>
          <el-table-column
              prop="orderNumber"
              label="SMT工单"
              min-width="110"
              align="center"
              show-overflow-tooltip
              sortable="custom"
          >
            <template slot-scope="scope">
              <span>{{scope.row.orderNumber}}</span>
            </template>
          </el-table-column>
          <el-table-column
              prop="customerId"
              label="客户"
              min-width="110"
              align="center"
              show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span v-if="scope.row.customer">{{scope.row.customer.name}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="productId" label="产品型号" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.product">{{scope.row.product.code}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="quantity" label="产品数量" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="status" label="状态" width="95px" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.status" class="textOverflow">{{scope.row.status.title}}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <pagination
        :pagination="pagination"
        @currentChange="currentChange"
        @sizeChange="sizeChange"
        @refreshBtn="getTableData"
      ></pagination>
    </template>
  </myDialog>
</template>

<script>
import myDialog from "@/components/myDialog.vue";
import pagination from "@/components/pagination.vue";
import { apiCustomerOrderSearch } from "@/api/customerOrder.js";
import { apiProductionOrderSearch, apiUserPEList } from "@/api/productionOrder.js";
import { apiShipmentOrderSearch } from "@/api/shipmentOrder.js";
import { apiUserList, apiUserPMList } from "@/api/userApi.js";
import { apiCartonOrderSearch } from "@/api/cartonOrder.js";
import { setLocalStorage, getLocalStorage } from "@/utils/myStorage.js";
import {apiSmtOrderSearch} from "@/api/SmtOrder";
export default {
  components: {
    myDialog,
    pagination
  },
  data() {
    return {
      labelName: "",  // 表格标题, 用于条件判断,区分不同的表格
      orderName: "",  // 被点击下拉框的部分参数名,后续返回, 组成输入框的value和下拉list列表
      origin: "",     // 来源, 被点击下拉框所在的form对象
      // 传递参数
      parameter: {},
      searchConditionForm: {},
      tableData: [],
      desc: undefined,
      orderBy: [],
      pagination: {
        currentPage: 1,
        pageSize: 40,
        total: 102,
        beginIndex: 1,
        endIndex: 10
      },
      // 表格选中
      selectRow: [],
      historySelectRow: [],
      localSelectRow: {},
      // 用户id
      userId: this.$store.state.userInfo.id
    };
  },
  computed: {
    filterHistory: function() {
      let newHistory = [];
      if (
        (this.labelName == "销售订单" ||
          this.labelName == "发货单" ||
          this.labelName == "包装工单") &&
        this.parameter.customerId
      ) {
        newHistory = this.historySelectRow.filter(item => {
          return item.customer.id == this.parameter.customerId;
        });
      } else if ((this.labelName == "组装工单" || this.labelName == "组装工单多选") && this.parameter.customerId) {
        // 组装工单 -- 客户有选(需要判断客户和销售订单)
        if (this.parameter.customerOrderId) {
          newHistory = this.historySelectRow.filter(item => {
            return (
              item.customer.id == this.parameter.customerId &&
              item.customerOrder.id == this.parameter.customerOrderId
            );
          });
        } else {
          newHistory = this.historySelectRow.filter(item => {
            return item.customer.id == this.parameter.customerId;
          });
        }
      } else if (
        this.labelName == "组装工单" &&
        this.parameter.customerOrderId
      ) {
        // 组装工单 -- 客户没选,(只需要判断销售订单)
        newHistory = this.historySelectRow.filter(item => {
          return item.customerOrder.id == this.parameter.customerOrderId;
        });
      } else {
        newHistory = this.historySelectRow;
      }
      return newHistory;
    }
  },
  methods: {
    // 手动打开对话框
    openDialog() {
      this.$refs.myDialog.dialogVisible = true;
      this.getTableData();
      this.localSelectRow = getLocalStorage("localSelectRow") || {};
      if (this.localSelectRow[this.userId]) {
        this.historySelectRow =
          this.localSelectRow[this.userId][this.orderName] || [];
      }
      if (this.labelName == "包装工单" || this.labelName == "组装工单多选") {
        this.selectRow = this.parameter.selectedRow || [];
      }
    },
    // 表格数据
    async getTableData() {
      let res = {};
      this.tableData = [];
      if (this.labelName == "销售订单") {
        res = await apiCustomerOrderSearch({
          orderNumber: this.searchConditionForm.orderNumber,
          customerId: this.parameter.customerId,
          pageNum: this.pagination.currentPage,
          pageSize: this.pagination.pageSize,
          desc: this.desc,
          orderBy: this.orderBy
        });
      } else if (this.labelName == "组装工单" || this.labelName == "组装工单多选") {
        res = await apiProductionOrderSearch({
          orderNumber: this.searchConditionForm.orderNumber,
          customerId: this.parameter.customerId,
          customerOrderId: this.parameter.customerOrderId,
          pageNum: this.pagination.currentPage,
          pageSize: this.pagination.pageSize,
          desc: this.desc,
          orderBy: this.orderBy
        });
      } else if (this.labelName == "发货单") {
        res = await apiShipmentOrderSearch({
          orderNumber: this.searchConditionForm.orderNumber,
          customerId: this.parameter.customerId,
          pageNum: this.pagination.currentPage,
          pageSize: this.pagination.pageSize,
          desc: this.desc,
          orderBy: this.orderBy
        });
      } else if (this.labelName == "员工选择") {
        if(this.orderName == "user" || this.orderName=="sales") {
          res = await apiUserList({
            key: this.searchConditionForm.key,
            pageNum: this.pagination.currentPage,
            pageSize: this.pagination.pageSize,
            desc: this.desc,
            orderBy: this.orderBy
          });
        } else if(this.orderName == "manager") {
          res = await apiUserPMList({
            key: this.searchConditionForm.key,
            pageNum: this.pagination.currentPage,
            pageSize: this.pagination.pageSize,
            desc: this.desc,
            orderBy: this.orderBy
          });
        }
      } else if (this.labelName == "包装工单") {
        res = await apiCartonOrderSearch({
          orderNumber: this.searchConditionForm.orderNumber,
          customerId: this.parameter.customerId,
          pageNum: this.pagination.currentPage,
          pageSize: this.pagination.pageSize,
          desc: this.desc,
          orderBy: this.orderBy
        });
      } else if (this.labelName == "PE工程师") {
        res = await apiUserPEList({
          key: this.searchConditionForm.key,
          pageNum: this.pagination.currentPage,
          pageSize: this.pagination.pageSize,
          desc: this.desc,
          orderBy: this.orderBy
        });
      }
      else if (this.labelName == "邮箱选择") {
        res = await apiUserList({
          key: this.searchConditionForm.key,
          pageNum: this.pagination.currentPage,
          pageSize: this.pagination.pageSize,
          desc: this.desc,
          orderBy: this.orderBy
        });
      } else if (this.labelName == "SMT工单") {
        res = await apiSmtOrderSearch({
          orderNumber: this.searchConditionForm.orderNumber,
          customerId: this.parameter.customerId,
          customerOrderId: this.parameter.customerOrderId,
          pageNum: this.pagination.currentPage,
          pageSize: this.pagination.pageSize,
          desc: this.desc,
          orderBy: this.orderBy
        });
      }
      if (res.code == 0) {
        this.tableData = res.data;
        this.pagination.total = res.total;
        this.pagination.beginIndex = res.beginIndex;
        this.pagination.endIndex = res.endIndex;

        if (this.labelName == "销售订单") {
          // 合并相同列名
          let obj = {};
          res.data.forEach(item => {
            if (obj[item.orderNumber]) {
              obj[item.orderNumber] += 1;
            } else {
              obj[item.orderNumber] = 1;
            }
          });
          res.data.forEach(item => {
            if (obj[item.orderNumber]) {
              item.rowspan = obj[item.orderNumber];
              obj[item.orderNumber] = 0;
            } else {
              item.rowspan = 0;
            }
          });
        } else if (this.labelName == "包装工单" || this.labelName == "组装工单多选") {
          // 包装工单跟组装工单多选都是支持多选的表格
          // 根据已选中数组项, 对表格行进行勾选
          this.selectRow.forEach(item => {
            this.selectRowArrayBtn(item);
          });
        }
      }
    },
    searchBtn() {
      this.pagination.currentPage = 1;
      this.getTableData();
    },
    // 表格行合并
    objectSpanMethod({ row, columnIndex }) {
      // columnIndex: 1-3列需要合并
      if (columnIndex == 1 || columnIndex == 2 || columnIndex == 3 || columnIndex == 4) {
        if (row.rowspan) {
          return {
            // 几行合一
            rowspan: row.rowspan,
            // 几列合一
            colspan: 1
          };
        } else {
          return {
            // 为0不合,且该单元格会消失
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    // 页码改变
    currentChange(val) {
      this.pagination.currentPage = val;
      this.getTableData();
    },
    // 页容量改变
    sizeChange(val) {
      this.pagination.currentPage = 1;
      this.pagination.pageSize = val;
      this.getTableData();
    },
    // 最近选择点击--单选
    selectRowBtn(item) {
      this.selectRow = item;
      this.$refs.multipleTable.clearSelection();
      this.$nextTick(() => {
        this.tableData.forEach(all => {
          if (all.id == item.id) {
            this.$refs.multipleTable.toggleRowSelection(all);
          }
        });
      });
    },
    // 最近选择点击--多选
    selectRowArrayBtn(item) {
      let selectRowIds = this.selectRow.map(item => item.id);
      if (!selectRowIds.includes(item.id)) this.selectRow.push(item);

      this.$nextTick(() => {
        this.tableData.forEach(all => {
          if (all.id == item.id) {
            this.$refs.multipleTable.toggleRowSelection(all, true);
          }
        });
      });
    },
    // 表格列全选按钮--单选
    selectAllChange() {
      this.$refs.multipleTable.clearSelection();
    },
    // 表格列点击按钮--单选
    selectChange(selectAll, row) {
      // console.log(selectAll, row)
      this.$refs.multipleTable.clearSelection();
      this.$refs.multipleTable.toggleRowSelection(row);
      this.selectRow = row;
    },
    // 表格列全选按钮--多选
    selectAllChange2(selection) {
      if (selection.length) {
        let selectRowIds = this.selectRow.map(item => item.id);
        selection.forEach(item => {
          if (!selectRowIds.includes(item.id)) this.selectRow.push(item);
        });
      } else {
        let tableIds = this.tableData.map(item => item.id);
        this.selectRow = this.selectRow.filter(item => {
          return !tableIds.includes(item.id);
        });
      }
    },
    // 表格列点击按钮--多选
    selectChange2(selection, row) {
      let selectRowIds = this.selectRow.map(item => item.id);
      if (selectRowIds.includes(row.id)) {
        this.selectRow.splice(selectRowIds.indexOf(row.id), 1);
      } else {
        this.selectRow.push(row);
      }
    },
    // 表格列点击按钮--多选
    selectChangeMail(selection, row) {
      let index = this.selectRow.indexOf(row.email);
      if(index < 0){
        this.selectRow.push(row.email);
      }
      
    },
    // 表格排序
    sortChange({ prop, order }) {
      this.orderBy[0] = prop;
      if (order == "ascending") {
        this.desc = false;
      } else if (order == "descending") {
        this.desc = true;
      } else {
        this.desc = undefined;
        this.orderBy = [];
      }
      this.getTableData();
    },
    // 对话框提交
    submitData() {
      let historyIds = this.historySelectRow.map(item => item.id);
      if (this.labelName == "包装工单" || this.labelName == "组装工单多选") {
        this.selectRow.sort(function(a, b) {
          let val1 = a.orderNumber;
          let val2 = b.orderNumber;
          if (val1 < val2) {
            return 1;
          } else if (val1 > val2) {
            return -1;
          } else {
            return 0;
          }
        });
        this.selectRow.forEach(item => {
          if (!historyIds.includes(item.id) && item.id) {
            this.historySelectRow.unshift(item);
            if (this.historySelectRow.length > 5) {
              this.historySelectRow.splice(5);
            }
            this.localSelectRow[this.userId] =
              this.localSelectRow[this.userId] || {};
            this.localSelectRow[this.userId][
              this.orderName
            ] = this.historySelectRow;
          }
        });
        setLocalStorage("localSelectRow", this.localSelectRow);
      } else {
        if (!historyIds.includes(this.selectRow.id) && this.selectRow.id) {
          this.historySelectRow.unshift(this.selectRow);
          if (this.historySelectRow.length > 5) {
            this.historySelectRow.splice(5);
          }
          this.localSelectRow[this.userId] =
            this.localSelectRow[this.userId] || {};
          this.localSelectRow[this.userId][
            this.orderName
          ] = this.historySelectRow;
          setLocalStorage("localSelectRow", this.localSelectRow);
        }
      }

      this.$refs.myDialog.dialogVisible = false;
      this.$emit("orderTableSubmit", {
        labelName: this.labelName,
        orderName: this.orderName,
        selectRow: this.selectRow,
        origin: this.origin
      });
    },
    // 对话框关闭
    dialogClose() {
      this.labelName = "";
      this.orderName = "";
      this.parameter = {};
      this.searchConditionForm = {};
      this.selectRow = [];
      this.desc = undefined;
      this.orderBy = [];
      this.pagination = {
        currentPage: 1,
        pageSize: 40,
        total: 102,
        beginIndex: 1,
        endIndex: 10
      };
    }
  }
};
</script>

<style lang="less" scoped>
.orderTableSelect {
  /deep/.el-dialog__body {
    height: 500px;
    padding: 10px 30px;
    .el-form {
      height: 30px;
      padding: 0;
      .formBox {
        display: inline-block;
        height: 100%;
      }
    }
    .selectRowBox {
      line-height: 30px;
      .rowItem {
        margin: 0 10px 0 5px;
        cursor: pointer;
      }
      .selectRowItem {
        color: var(--themeColor);
      }
    }
    .tableBox {
      height: 392px;
      .el-table {
        font-size: 14px;
      }
    }
    .paginPage {
      height: 48px;
    }
  }
}
</style>